import {makeStyles} from '@mui/styles'
import {FC, useMemo} from 'react'

import {useCompileChatMessageText} from '../../../hooks/useCompileChatMessageText'
import {
  ChatMessages,
  ChatMessageTemplates,
  ChatMessageTemplateValues,
} from '../../../types/graphqlSchema'
import FormattedChatMessageText from '../../FormattedChatMessageText'

const ChatMessageText: FC<ChatMessageTextProps> = ({
  chatMessageTemplate,
  chatMessageTemplateValues,
  forwardedChatMessage,
  text,
}) => {
  const styles = useStyles()
  const {compileChatMessageText} = useCompileChatMessageText()
  const compiledText = useMemo(
    () => compileChatMessageText(
      (text && {text}) ||
      forwardedChatMessage ||
      ({chatMessageTemplate, chatMessageTemplateValues})
    ),
    [
      chatMessageTemplate,
      chatMessageTemplateValues,
      compileChatMessageText,
      forwardedChatMessage,
      text,
    ],
  )
  if (!compiledText) return null
  return (
    <div className={`${styles.root} ${forwardedChatMessage ? styles.forwarded : ''}`}>
      <FormattedChatMessageText text={compiledText} />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  forwarded: {
    fontStyle: 'italic',
  },
  root: {
    color: theme.palette.primary.main,
    paddingBottom: '0',
    ...theme.typography.body1,
    position: 'relative',
  },
}))

interface ChatMessageTextProps {
  chatMessageTemplate?: ChatMessageTemplates
  chatMessageTemplateValues: ChatMessageTemplateValues[]
  forwardedChatMessage?: ChatMessages
  text?: string,
}

export default ChatMessageText
